module.exports = __webpack_public_path__ + "img/man-with-ipad.dcf72daa.png";